import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { FeaturesBlock } from "../components/FeaturesBlock";

type IProps = Immutable<templates.FeaturesBlockTemplate>;

export const Template = (props: IProps): React.JSX.Element => {
    return <FeaturesBlock value={props.value} />;
};
